export const validateCallLogs = (data, endpoint, response) => {
    if (!Array.isArray(data)) {
        const shape = data === null ? 'null' : typeof data
        const keys = data && typeof data === 'object' ? `; keys: ${Object.keys(data).slice(0, 10).join(', ')}` : ''
        const http = response ? `; HTTP ${response.status}; Content-Type: ${(response.headers && response.headers['content-type']) || 'unknown'}` : ''
        const error = new TypeError(`Invalid call-log response from ${endpoint}: expected an array, received ${shape}${keys}${http}`)
        error.invalidCallLogsResponse = true
        throw error
    }
    return data.filter(row => row && typeof row === 'object' && !Array.isArray(row))
}
